import { useEffect } from "react";
import Lenis from "lenis";
import { Navbar } from "./components/landing/Navbar";
import { Hero } from "./components/landing/Hero";
import { Stats } from "./components/landing/Stats";
import { Marquee } from "./components/landing/Marquee";
import { Features } from "./components/landing/Features";
import { Modules } from "./components/landing/Modules";
import { ChatbotSpotlight } from "./components/landing/ChatbotSpotlight";
import { HowItWorks } from "./components/landing/HowItWorks";
import { Team } from "./components/landing/Team";
import { Footer } from "./components/landing/Footer";

function App() {
    useEffect(() => {
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
        const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
        window.__lenis = lenis;
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <div id="top" className="min-h-screen bg-[var(--bg)] text-[var(--ink)] antialiased">
            <Navbar />
            <main>
                <Hero />
                <Stats />
                <Marquee />
                <Features />
                <Modules />
                <ChatbotSpotlight />
                <HowItWorks />
                <Team />
            </main>
            <Footer />
        </div>
    );
}

export default App;
